var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBitcoincolor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 502.4 502.4",
    style: {
      enableBackground: "new 0 0 502.4 502.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBAB56"
    },
    d: "M251.2,502.4c-134.4,0-244-109.6-244-244s109.6-244,244-244s244,109.6,244,244 S385.6,502.4,251.2,502.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EFB30C"
    },
    cx: 251.2,
    cy: 244,
    r: 228.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5A300"
    },
    d: "M49.6,271.2C49.6,144.8,152,42.4,278.4,42.4c56,0,108,20,147.2,53.6c-41.6-48.8-104-80.8-174.4-80.8 C124.8,15.2,22.4,117.6,22.4,244c0,70.4,31.2,132.8,80.8,174.4C70.4,379.2,49.6,327.2,49.6,271.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5A300"
    },
    d: "M412.8,82.4c89.6,89.6,89.6,234.4,0,323.2c-89.6,89.6-233.6,89.6-323.2,0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M251.2,488c-134.4,0-244-109.6-244-244S116.8,0,251.2,0s244,109.6,244,244S385.6,488,251.2,488z  M251.2,31.2c-117.6,0-213.6,96-213.6,213.6s96,213.6,213.6,213.6s213.6-96,213.6-213.6C464.8,126.4,368.8,31.2,251.2,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M495.2,244c0-61.6-23.2-117.6-60.8-160.8c-43.2-37.6-99.2-60.8-160.8-60.8c-40.8,0-80,10.4-113.6,28 c28-12.8,58.4-20.8,91.2-20.8c64.8,0,122.4,28.8,161.6,74.4c45.6,39.2,74.4,96.8,74.4,161.6c0,32.8-7.2,63.2-20.8,91.2 C484.8,324,495.2,285.6,495.2,244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC06C"
    },
    d: "M30.4,267.2c0,61.6,23.2,117.6,60.8,160.8c43.2,37.6,99.2,60.8,160.8,60.8c40.8,0,80-10.4,113.6-28 c-28,12.8-58.4,20.8-91.2,20.8c-64.8,0-122.4-28.8-161.6-74.4C67.2,366.4,37.6,308.8,37.6,244c0-32.8,7.2-63.2,20.8-91.2 C40,187.2,30.4,225.6,30.4,267.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5A300"
    },
    d: "M264.8,90.4c0,7.2-6.4,20-13.6,20s-13.6-12-13.6-20s6.4-13.6,13.6-13.6S264.8,83.2,264.8,90.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F7D27F"
    },
    cx: 251.2,
    cy: 90.4,
    r: 13.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M260.8,80.8c5.6,5.6,5.6,14.4,0,19.2c-5.6,5.6-14.4,5.6-19.2,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M252.8,23.2c0,0.8-0.8,1.6-1.6,1.6l0,0c-0.8,0-1.6-0.8-1.6-1.6v-16c0-0.8,0.8-1.6,1.6-1.6l0,0 c0.8,0,1.6,0.8,1.6,1.6V23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M252.8,481.6c0,0.8-0.8,1.6-1.6,1.6l0,0c-0.8,0-1.6-0.8-1.6-1.6v-16c0-0.8,0.8-1.6,1.6-1.6l0,0 c0.8,0,1.6,0.8,1.6,1.6V481.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M408.8,88.8c-0.8,0.8-2.4,0.8-2.4,0l0,0c-0.8-0.8-0.8-1.6,0-2.4l11.2-11.2c0.8-0.8,2.4-0.8,2.4,0 l0,0c0.8,0.8,0.8,2.4,0,2.4L408.8,88.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M84.8,412.8c-0.8,0.8-2.4,0.8-2.4,0l0,0c-0.8-0.8-0.8-2.4,0-2.4l11.2-11.2c0.8-0.8,2.4-0.8,2.4,0 l0,0c0.8,0.8,0.8,2.4,0,2.4L84.8,412.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M472.8,246.4c-0.8,0-1.6-0.8-1.6-1.6l0,0c0-0.8,0.8-1.6,1.6-1.6h16c0.8,0,1.6,0.8,1.6,1.6l0,0 c0,0.8-0.8,1.6-1.6,1.6H472.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M14.4,246.4c-0.8,0-1.6-0.8-1.6-1.6l0,0c0-0.8,0.8-1.6,1.6-1.6h16c0.8,0,1.6,0.8,1.6,1.6l0,0 c0,0.8-0.8,1.6-1.6,1.6H14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M406.4,402.4c-0.8-0.8-0.8-1.6,0-2.4l0,0c0.8-0.8,1.6-0.8,2.4,0l11.2,11.2c0.8,0.8,0.8,2.4,0,2.4 l0,0c-0.8,0.8-2.4,0.8-2.4,0L406.4,402.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M82.4,77.6c-0.8-0.8-0.8-1.6,0-2.4l0,0c0.8-0.8,2.4-0.8,2.4,0L96,86.4c0.8,0.8,0.8,2.4,0,2.4l0,0 c-0.8,0.8-2.4,0.8-2.4,0L82.4,77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M142.4,51.2c0.8,0.8,0,2.4-0.8,2.4l0,0c-0.8,0.8-2.4,0-2.4-0.8l-8-13.6c-0.8-0.8,0-2.4,0.8-2.4l0,0 c0.8-0.8,2.4,0,2.4,0.8L142.4,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M371.2,448.8c0.8,0.8,0,2.4-0.8,2.4l0,0c-0.8,0.8-2.4,0-2.4-0.8l-8-13.6c-0.8-0.8,0-2.4,0.8-2.4l0,0 c0.8-0.8,2.4,0,2.4,0.8L371.2,448.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M310.4,31.2c0,0.8-1.6,1.6-2.4,1.6l0,0c-0.8,0-1.6-1.6-1.6-2.4l4-15.2c0-0.8,1.6-1.6,2.4-1.6l0,0 c0.8,0,1.6,1.6,1.6,2.4L310.4,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M192,473.6c0,0.8-1.6,1.6-2.4,1.6l0,0c-0.8,0-1.6-1.6-1.6-2.4l4-15.2c0-0.8,1.6-1.6,2.4-1.6l0,0 c0.8,0,1.6,1.6,1.6,2.4L192,473.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M444,135.2c-0.8,0.8-2.4,0-2.4-0.8l0,0c-0.8-0.8,0-2.4,0.8-2.4l13.6-8c0.8-0.8,2.4,0,2.4,0.8l0,0 c0.8,0.8,0,2.4-0.8,2.4L444,135.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M47.2,364.8c-0.8,0.8-2.4,0-2.4-0.8l0,0c-0.8-0.8,0-2.4,0.8-2.4l13.6-8c0.8-0.8,2.4,0,2.4,0.8l0,0 c0.8,0.8,0,2.4-0.8,2.4L47.2,364.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M464.8,303.2c-0.8,0-1.6-1.6-1.6-2.4l0,0c0-0.8,1.6-1.6,2.4-1.6l15.2,4c0.8,0,1.6,1.6,1.6,2.4l0,0 c0,0.8-1.6,1.6-2.4,1.6L464.8,303.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M21.6,184.8c-0.8,0-1.6-1.6-1.6-2.4l0,0c0-0.8,1.6-1.6,2.4-1.6l15.2,4c0.8,0,1.6,1.6,1.6,2.4l0,0 c0,0.8-1.6,1.6-2.4,1.6L21.6,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M60.8,132c0.8,0.8,1.6,1.6,0.8,2.4l0,0c-0.8,0.8-1.6,1.6-2.4,0.8l-13.6-8c-0.8-0.8-1.6-1.6-0.8-2.4 l0,0c0.8-0.8,1.6-1.6,2.4-0.8L60.8,132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M457.6,360.8c0.8,0.8,1.6,1.6,0.8,2.4l0,0c-0.8,0.8-1.6,1.6-2.4,0.8l-13.6-8 c-0.8-0.8-1.6-1.6-0.8-2.4l0,0c0.8-0.8,1.6-1.6,2.4-0.8L457.6,360.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M196,29.6c0,0.8,0,2.4-1.6,2.4l0,0c-0.8,0-2.4,0-2.4-1.6l-4-15.2c0-0.8,0-2.4,1.6-2.4l0,0 c0.8,0,2.4,0,2.4,1.6L196,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M314.4,472.8c0,0.8,0,2.4-1.6,2.4l0,0c-0.8,0-2.4,0-2.4-1.6l-4-15.2c0-0.8,0-2.4,1.6-2.4l0,0 c0.8,0,2.4,0,2.4,1.6L314.4,472.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M363.2,53.6c-0.8,0.8-1.6,1.6-2.4,0.8l0,0c-0.8-0.8-1.6-1.6-0.8-2.4l8-13.6c0.8-0.8,1.6-1.6,2.4-0.8 l0,0c0.8,0.8,1.6,1.6,0.8,2.4L363.2,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M134.4,450.4c-0.8,0.8-1.6,1.6-2.4,0.8l0,0c-0.8-0.8-1.6-1.6-0.8-2.4l8-13.6 c0.8-0.8,1.6-1.6,2.4-0.8l0,0c0.8,0.8,1.6,1.6,0.8,2.4L134.4,450.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M465.6,188.8c-0.8,0-2.4,0-2.4-1.6l0,0c0-0.8,0-2.4,1.6-2.4l15.2-4c0.8,0,2.4,0,2.4,1.6l0,0 c0,0.8,0,2.4-1.6,2.4L465.6,188.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE0A1"
    },
    d: "M22.4,307.2c-0.8,0-2.4,0-2.4-1.6l0,0c0-0.8,0-2.4,1.6-2.4l15.2-4c0.8,0,2.4,0,2.4,1.6l0,0 c0,0.8,0,2.4-1.6,2.4L22.4,307.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M132,331.2c-0.8,0-1.6,0-2.4-0.8c-36-15.2-52.8-56.8-37.6-93.6c1.6-3.2,4.8-4.8,8-3.2s4.8,4.8,3.2,8 c-6.4,14.4-6.4,30.4,0,44.8c5.6,14.4,16.8,26.4,32,32c3.2,1.6,4.8,4.8,3.2,8C136,330.4,134.4,331.2,132,331.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M102.4,288c-4.8-12-5.6-25.6-2.4-38.4c0-4,0.8-8,2.4-12c-0.8-1.6-1.6-2.4-3.2-3.2 c-3.2-1.6-6.4,0-8,3.2s-2.4,6.4-3.2,9.6c-3.2,30.4,13.6,60.8,43.2,72.8c0.8,0,1.6,0.8,2.4,0.8c0.8,0,0.8,0,1.6,0l-0.8-0.8 C120,313.6,108.8,302.4,102.4,288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M123.2,188.8c-8.8,0-18.4,7.2-24.8,19.2s-1.6,15.2,3.2,22.4L123.2,188.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M123.2,188.8c4.8,7.2,4.8,19.2-0.8,31.2c-6.4,12-11.2,10.4-20,10.4L123.2,188.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M70.4,206.4c5.6-0.8,12,4,16.8,11.2s1.6,9.6-0.8,14.4L70.4,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M70.4,206.4c-3.2,4.8-2.4,12,2.4,19.2c4.8,7.2,8,5.6,13.6,5.6L70.4,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M142.4,236c-4.8-4.8-13.6-5.6-22.4-3.2c-9.6,3.2-8.8,7.2-9.6,13.6L142.4,236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M142.4,236c-0.8,6.4-7.2,12.8-16.8,16c-9.6,3.2-11.2-0.8-16-4.8L142.4,236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M135.2,264c-4-4-11.2-4.8-18.4-2.4c-7.2,2.4-7.2,5.6-8,11.2L135.2,264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M135.2,264c-0.8,4.8-6.4,10.4-13.6,12.8c-7.2,2.4-8.8-0.8-12.8-4L135.2,264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M57.6,240c4.8-2.4,12-1.6,18.4,2.4s5.6,7.2,4.8,12.8L57.6,240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M57.6,240c-0.8,4.8,3.2,11.2,9.6,16c6.4,4,8.8,1.6,13.6-0.8L57.6,240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M58.4,268.8c3.2-3.2,8.8-4.8,16-3.2c6.4,1.6,6.4,4.8,7.2,8.8L58.4,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M58.4,268.8c0.8,4,5.6,8.8,12.8,10.4c6.4,1.6,8-0.8,10.4-4L58.4,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M63.2,294.4c2.4-4,8.8-5.6,15.2-4.8c6.4,0.8,7.2,4,8.8,8L63.2,294.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M63.2,294.4c1.6,4,7.2,8,13.6,8.8s8-1.6,10.4-5.6L63.2,294.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M80,318.4c1.6-3.2,5.6-6.4,12-6.4c5.6-0.8,6.4,1.6,8,4.8L80,318.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M80,318.4c1.6,3.2,7.2,4.8,12.8,4.8c5.6-0.8,5.6-3.2,7.2-6.4L80,318.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M103.2,336c0-3.2,2.4-6.4,7.2-8.8c4-2.4,5.6-0.8,8,0.8L103.2,336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M103.2,336c2.4,1.6,7.2,1.6,11.2-0.8s4-4,4-7.2L103.2,336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M137.6,283.2c-4-2.4-10.4-1.6-16,1.6c-5.6,3.2-4.8,6.4-4.8,10.4L137.6,283.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M137.6,283.2c0,4.8-3.2,9.6-8.8,13.6c-5.6,3.2-8,1.6-12-0.8L137.6,283.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M143.2,299.2c-3.2-1.6-8,0-12,4c-4,4-3.2,5.6-1.6,8.8L143.2,299.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M143.2,299.2c0.8,3.2-0.8,8-4.8,12s-5.6,2.4-8.8,0.8L143.2,299.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M370.4,331.2c0.8,0,1.6,0,2.4-0.8c36-15.2,52.8-56.8,37.6-93.6c-1.6-3.2-4.8-4.8-8-3.2 s-4.8,4.8-3.2,8c6.4,14.4,6.4,30.4,0,44.8c-5.6,14.4-16.8,26.4-32,32c-3.2,1.6-4.8,4.8-3.2,8C366.4,330.4,368,331.2,370.4,331.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M400,288c4.8-12,5.6-25.6,2.4-38.4c0-4-0.8-8-2.4-12c0.8-1.6,1.6-2.4,3.2-3.2c3.2-1.6,6.4,0,8,3.2 s2.4,6.4,3.2,9.6c3.2,30.4-13.6,60.8-43.2,72.8c-0.8,0-1.6,0.8-2.4,0.8s-0.8,0-1.6,0l0.8-0.8C382.4,313.6,393.6,302.4,400,288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M379.2,188.8c8.8,0,18.4,7.2,24.8,19.2s1.6,15.2-3.2,22.4L379.2,188.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M379.2,188.8c-4.8,7.2-4.8,19.2,0.8,31.2c6.4,12,11.2,10.4,20,10.4L379.2,188.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M432,206.4c-5.6-0.8-12,4-16.8,11.2s-1.6,9.6,0.8,14.4L432,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M432,206.4c3.2,4.8,2.4,12.8-2.4,20s-8,5.6-13.6,5.6L432,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M360,236c4.8-4.8,13.6-5.6,22.4-3.2c9.6,3.2,8.8,7.2,9.6,13.6L360,236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M360,236c0.8,6.4,7.2,12.8,16.8,16c9.6,3.2,11.2-0.8,16-4.8L360,236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M367.2,264c4-4,11.2-4.8,18.4-2.4c7.2,2.4,7.2,5.6,8,11.2L367.2,264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M367.2,264c0.8,4.8,6.4,10.4,13.6,12.8s8.8-0.8,12.8-4L367.2,264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M444.8,240c-4.8-2.4-12-1.6-18.4,2.4s-5.6,7.2-4.8,12.8L444.8,240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M444.8,240c0.8,4.8-3.2,11.2-9.6,16c-6.4,4-8.8,1.6-13.6-0.8L444.8,240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M444,268.8c-3.2-3.2-8.8-4.8-16-3.2c-6.4,1.6-6.4,4.8-7.2,8.8L444,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M444,268.8c-0.8,4-5.6,8.8-12.8,10.4c-6.4,1.6-8-0.8-10.4-4L444,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M439.2,294.4c-2.4-4-8.8-5.6-15.2-4.8c-6.4,0.8-7.2,4-8.8,8L439.2,294.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M439.2,294.4c-1.6,4-7.2,8-13.6,8.8s-8-1.6-10.4-5.6L439.2,294.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M422.4,318.4c-1.6-3.2-5.6-6.4-12-6.4c-5.6-0.8-6.4,1.6-8,4.8L422.4,318.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M422.4,318.4c-1.6,3.2-7.2,4.8-12.8,4.8c-5.6-0.8-5.6-3.2-7.2-6.4L422.4,318.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M399.2,336c0-3.2-2.4-6.4-7.2-8.8c-4-2.4-5.6-0.8-8,0.8L399.2,336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M399.2,336c-2.4,1.6-7.2,1.6-11.2-0.8s-4-4-4-7.2L399.2,336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M364.8,283.2c4-2.4,10.4-1.6,16,1.6s4.8,6.4,4.8,10.4L364.8,283.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M364.8,283.2c0,4.8,3.2,9.6,8.8,13.6c5.6,3.2,8,1.6,11.2-0.8L364.8,283.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D27F"
    },
    d: "M359.2,299.2c3.2-1.6,8,0,12,4s3.2,5.6,1.6,8.8L359.2,299.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC273"
    },
    d: "M359.2,299.2c-0.8,3.2,0.8,8,4.8,12s5.6,2.4,8.8,0.8L359.2,299.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9E310"
    },
    d: "M308.8,264.8c12-9.6,20-24.8,20-41.6v-1.6c0-28.8-22.4-52-50.4-52.8v-23.2c0-6.4-5.6-12-12-12 s-12,5.6-12,12v23.2H244v-23.2c0-6.4-5.6-12-12-12s-12,5.6-12,12v23.2h-28.8c-6.4,0-12,5.6-12,12s5.6,12,12,12h29.6v0.8 c-0.8,1.6-0.8,2.4-0.8,4v140.8h-28.8c-6.4,0-12,5.6-12,12s5.6,12,12,12H220v26.4c0,6.4,5.6,12,12,12s12-5.6,12-12v-26.4h10.4v26.4 c0,6.4,5.6,12,12,12s12-5.6,12-12v-27.2c28-0.8,50.4-24,50.4-52.8v-1.6C328.8,289.6,320.8,275.2,308.8,264.8z M305.6,308 c0,16-12.8,29.6-29.6,29.6h-32V196.8c0-1.6,0-2.4-0.8-4V192H276c16,0,29.6,12.8,29.6,29.6v1.6c0,16-12.8,29.6-29.6,29.6 c-6.4,0-12,5.6-12,12c0,0,0,0,0,0.8l0,0c0,6.4,5.6,12,12,12c16,0,29.6,12.8,29.6,29.6V308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7C011"
    },
    d: "M305.6,221.6v1.6c0,16-12.8,29.6-29.6,29.6c-6.4,0-12,5.6-12,12c0,0,0,0,0,0.8l0,0 c0,6.4,5.6,12,12,12c16,0,29.6,12.8,29.6,29.6v1.6c0,16-12.8,29.6-29.6,29.6h-32v-87.2l-24,24v62.4h-28.8c-6.4,0-12,5.6-12,12 s5.6,12,12,12H220V388c0,6.4,5.6,12,12,12s12-5.6,12-12v-26.4h10.4V388c0,6.4,5.6,12,12,12s12-5.6,12-12v-27.2 c28-0.8,50.4-24,50.4-52.8v-1.6c0-16.8-8-32-20-41.6c12-9.6,20-24.8,20-41.6v-1.6c0-15.2-6.4-28.8-16.8-38.4L295.2,200 C301.6,205.6,305.6,213.6,305.6,221.6z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoincolor);
export default __webpack_public_path__ + "static/media/bitcoincolor.f0b149724f28a50eb837cb4d11ffa396.svg";
export { ForwardRef as ReactComponent };